import { __awaiter, __generator } from "tslib";
import { createDebugLogger, isInIframe, } from '../../../client/src/modules/_core/utils/app-utils';
import at from 'lodash-es/at';
import { BubbleChannel } from '../../../client/src/modules/_core/components/BubbleChannel';
import { alertModal, confirmModal } from '../../../client/src/modules/domain/app-modal';
import { ChatThreadClass } from '../../../client/src/modules/chat/components/ChatThread/ChatThread';
import { getClientConfig, removeSessionThreadId, } from '../../../client/src/modules/_core/utils/app-storage';
import { url } from '../../../client/src/modules/_core/url';
import { dataLayerPush, isJuro } from '../_externals-utils';
import { ChatMessageType } from '../../../client/src/_library/domain-base/BaseChatMessage';
import { _inactivate } from '../../../client/src/_library/utils/thread-heartbeat';
import { dispatchUiState } from '../../../client/src/modules/domain/ui-state';
var debug = createDebugLogger('header-close-handler');
export var headerOnCloseHandler = function (cmp, _a) {
    var event = _a.event, closeBubble = _a.closeBubble, hideBubble = _a.hideBubble;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, dispatch, isAgent, threadId, DEFAULT_X_COMMAND, confirmClose, endOrClose;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = cmp.props, dispatch = _b.dispatch, isAgent = _b.isAgent;
                    threadId = at(cmp.props, ['match.params.threadId'])[0];
                    DEFAULT_X_COMMAND = getClientConfig().DEFAULT_X_COMMAND;
                    confirmClose = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, confirmModal(dispatch, {
                                    body: isJuro()
                                        ? 'Naozaj chceš pomocnú ruku odmietnuť?'
                                        : 'Naozaj chcete ukončiť komunikáciu?',
                                    labelOK: 'Áno',
                                    labelCancel: 'Nie',
                                })];
                        });
                    }); };
                    endOrClose = function () {
                        // https://docs.google.com/spreadsheets/d/1WDsoIs_v0Dc1sOASo0k0ugUbb2i7o3QaJj6NyZisKAQ/edit#gid=0
                        dataLayerPush({ eventAction: 'UpperCornerClick', eventLabel: 'Close' });
                        var doDefaultHideOrClose = function () {
                            return DEFAULT_X_COMMAND === BubbleChannel.COMMAND_HIDE
                                ? hideBubble()
                                : closeBubble();
                        };
                        var canClose = !isAgent || !threadId || cmp.props.endChatRequestIssued;
                        if (canClose) {
                            // remove any reference to active thread
                            removeSessionThreadId();
                            _inactivate(threadId, { event: 'CLOSED_MANUALLY_BY_USER' });
                            cmp.props.history.replace(url.CHAT_START());
                            // reset flag
                            dispatchUiState(dispatch, { chat_end_request_issued: false });
                            // hide bubble
                            doDefaultHideOrClose();
                            return;
                        }
                        if (threadId) {
                            ChatThreadClass.submitMessage({ dispatch: dispatch, identity: null, threadId: threadId }, '__end_chat__', ChatMessageType.HIDDEN);
                        }
                        dispatchUiState(dispatch, {
                            chat_end_request_issued: true,
                        });
                    };
                    if (!!isInIframe()) return [3 /*break*/, 2];
                    // alert('Close button works in bubble only!');
                    return [4 /*yield*/, alertModal(dispatch, { body: cmp.debugCloseNoopMsg })];
                case 1:
                    // alert('Close button works in bubble only!');
                    _c.sent();
                    return [2 /*return*/];
                case 2:
                    if (!cmp.props.showConfirmOnBubbleClose) return [3 /*break*/, 4];
                    return [4 /*yield*/, confirmClose()];
                case 3:
                    if (_c.sent()) {
                        endOrClose();
                    }
                    return [3 /*break*/, 5];
                case 4:
                    endOrClose();
                    _c.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    });
};
